import React from "react";
import { Trans, useTranslation } from "react-i18next";

export default function T(props) {
  const { t } = useTranslation();
  return (
    <Trans
      t={t}
      i18nKey={props.i18nKey}
      values={props.values || {}}
      components={{ italic: <i />, bold: <strong /> }}
    />
  );
  //return <>{t(props.i18nKey)}</>;
}
